import httpManager from "@/app/shared/utils/httpManager";
/**
 * Obtener todos los usuarios registrados.
 *
 * @return {Promise<Array>} Lista de usuarios.
 * @param {Object} pagination Paginación
 */
import { TABLE_PAGE_SIZE } from "@/app/shared/utils/constants";

export default async function (pagination = {}) {
  const offset = (pagination.current - 1 || 0) * TABLE_PAGE_SIZE;
  const pageSize = pagination.pageSize || TABLE_PAGE_SIZE;

  const url = `/users/?offset=${offset}&limit=${pageSize}`;
  const response = await httpManager.get(url);
  return response?.data;
}
